import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import word from "assets/img/file_word.png";
import excel from "assets/img/file_excel.png";
import pdf from "assets/img/file_pdf.png";
import ppt from "assets/img/file_pp.png";
import video from "assets/img/file_video.png";
import other from "assets/img/file_other.png";
import Form from "components/react-validation/components/form";

import * as LotActionType from "../constants";
import "../categoryModal.scss";

export class InventoryCategoryModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    onDrop: PropTypes.func,
    accept: PropTypes.string,
    dispatch: PropTypes.func,
    homeownerLotSelectList: PropTypes.array,
    HomeownerDocumentCategory: PropTypes.array,
    lot: PropTypes.object,
    selectedCategory: PropTypes.object,
    getDocumentByCategory: PropTypes.func,
    fetchInventoryCategories: PropTypes.func,
    isEdit: PropTypes.bool,
    category: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
      documents: [],
      uploading: false,
      uploadProgress: 0,
      uploadMessage: "",
      selectedLotId: null,
      lotDetails: null,
      activeKey: "1",
      showDocumentInfo: true,
      lot: this.props.lot,
      editingState: {},
      documentCategories: this.props.selectedCategory
        ? this.props.selectedCategory
        : {},
      expandedPanels: {},
      editCategoryIndex: null,
      categoryName: this.props.isEdit ? this.props.selectedCategory.name : "",
      categoryNote: this.props.isEdit ? this.props.selectedCategory.notes : "",
    };
  }

  componentDidMount() {
    if (this.props.isEdit && this.props.selectedCategory) {
      const { name, notes } = this.props.selectedCategory;
      this.setState({
        categoryName: name || "",
        categoryNote: notes || "",
        formSubmitted: false,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      const isEdit = this.props.isEdit;
      const selectedCategory = this.props.selectedCategory || {};

      this.setState({
        categoryName: isEdit ? selectedCategory.name || "" : "",
        categoryNote: isEdit ? selectedCategory.notes || "" : "",
        documents: [],
        documentCategories: {},
        expandedPanels: {},
        editingState: {},
        errorMessage: "",
        uploadProgress: 0,
        uploadMessage: "",
      });
    }
    if (
      prevProps.HomeownerDocumentCategory !==
        this.props.HomeownerDocumentCategory &&
      this.props.HomeownerDocumentCategory.length > 0 &&
      this.state.activeKey === "1"
    ) {
      this.setState({ activeKey: "0" });
    }

    if (
      this.props.files &&
      this.props.files !== prevProps.files &&
      this.props.files.length > 0
    ) {
      const expandedPanels = { ...this.state.expandedPanels };
      this.props.files.forEach((_, index) => {
        if (!(index in expandedPanels)) {
          expandedPanels[index] = true;
        }
      });

      this.setState({ expandedPanels });
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  onEditStart = (index) => {
    this.setState((prevState) => ({
      editingState: {
        ...prevState.editingState,
        [index]: true,
      },
    }));
  };

  onEditCancel = (index) => {
    this.setState((prevState) => ({
      editingState: {
        ...prevState.editingState,
        [index]: false,
      },
    }));
  };

  onFileNameChange = (index, newName) => {
    this.setState((prevState) => {
      const updatedFiles = [...prevState.documents];
      updatedFiles[index].overrideName = newName;
      return { documents: updatedFiles };
    });
  };

  onSubmit = () => {
    const { documents, lot, isEdit, categoryName, categoryNote } = this.state;
    const { builderProfile } = this.props.lot.extensionValue;
    this.setState({ formSubmitted: true });

    const formData = this.form.getValues();
    if (isEdit) {
      this.onEditSubmit();
    } else {
      const formDataToSend = new FormData();
      formDataToSend.append("Name", categoryName);
      formDataToSend.append("LotId", this.props.lot.value);
      formDataToSend.append("Note", categoryNote);

      if (documents[0]) {
        formDataToSend.append("CategoryImage", documents[0]);
      }

      this.props.dispatch({
        type: LotActionType.ADD_NEW_INVENTORY_CATEGORY,
        params: {
          headers: {
            url: builderProfile.builderHost,
          },
          data: formDataToSend,
        },
        callback: () => {
          this.setState({ uploading: false }, () => {
            this.props.fetchInventoryCategories();
            this.props.closeModal();
          });
        },
      });
    }
  };

  onEditSubmit = () => {
    const { documents, documentCategories, lot, categoryName, categoryNote } =
      this.state;
    const { builderProfile } = this.props.lot.extensionValue;
    const { selectedCategory } = this.props;
    this.setState({ formSubmitted: true });

    const formData = this.form.getValues();

    const formDataToSend = new FormData();
    formDataToSend.append("Name", categoryName);
    formDataToSend.append("LotId", this.props.lot.value);
    formDataToSend.append("Note", categoryNote);
    formDataToSend.append("Id", selectedCategory.id);
    formDataToSend.append(
      "IsBuilderSharedCategory",
      selectedCategory.isBuilderUploaded
    );

    if (documents[0]) {
      formDataToSend.append("CategoryImage", documents[0]);
    }

    for (let pair of formDataToSend.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    this.props.dispatch({
      type: LotActionType.UPDATE_INVENTORY_CATEGORY,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: formDataToSend,
      },
      callback: () => {
        this.setState({ uploading: false }, () => {
          this.props.fetchInventoryCategories();
          this.props.closeModal();
        });
      },
    });
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = () => {
    this.setState({ isDragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });

    const files = Array.from(e.dataTransfer.files);

    const accepted = [];
    const rejected = [];

    files.forEach((file) => {
      if (
        ["application/pdf", "image/png", "image/jpg", "image/jpeg", "image/webp"].includes(
          file.type
        )
      ) {
        accepted.push(file);
      } else {
        rejected.push(file);
      }
    });

    if (this.props.onDrop) {
      this.props.onDrop(accepted, rejected);
    }
  };

  handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const currentDocuments = this.state.documents;
    const currentCategories = this.state.documentCategories;
    if (selectedFiles.length === 0) return;
    if (selectedFiles.length > 1) {
      this.setState({ errorMessage: "Please select only one image." });
      return;
    }

    const accepted = [];
    const rejected = [];

    selectedFiles.forEach((file) => {
      const isAcceptedType = ["image/png", "image/jpg", "image/jpeg", "image/webp"].includes(
        file.type
      );

      const isValidSize = file.size <= 100 * 1024 * 1024; // 100MB in bytes

      if (isAcceptedType && isValidSize) {
        accepted.push(file);
      } else {
        rejected.push(file);
      }
    });

    if (rejected.length > 0) {
      this.setState({
        errorMessage:
          "Each file must be under 100MB and a valid file type. Type allowed: jpg, png, jpeg, webp",
      });
      return;
    }

    if (this.props.onDrop) {
      this.props.onDrop(accepted, rejected);
    }

    const updatedDocuments = [...accepted]; // just one file
    const updatedCategories = { ...currentCategories };
    const expandedPanels = { ...this.state.expandedPanels };
    const editingState = { ...this.state.editingState };
    const defaultCategory = this.props.selectedCategory;
    const defaultCategoryValue =
      defaultCategory && defaultCategory.length > 0
        ? defaultCategory[0].value
        : null;

    accepted.forEach((file, index) => {
      const docIndex = currentDocuments.length + index;
      updatedCategories[docIndex] = defaultCategoryValue;
      expandedPanels[docIndex] = true;
      editingState[docIndex] = false;
    });

    this.setState({
      documents: updatedDocuments,
      documentCategories: updatedCategories,
      expandedPanels,
      editingState,
      errorMessage: "",
    });
  };

  renderFileTypeIcon = (item) => {
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif", "webp"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];

    const fileName = item.fileName || item.name;
    if (!fileName) return other;

    const ext = fileName.split(".").pop().toLowerCase();

    if (extWord.includes(ext)) {
      return word;
    } else if (extExcel.includes(ext)) {
      return excel;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extVideo.includes(ext)) {
      return video;
    } else if (ext === "pdf") {
      return pdf;
    } else if (extImage.includes(ext)) {
      return item.url || URL.createObjectURL(item);
    } else {
      return other;
    }
  };

  render() {
    const { isDragging } = this.state;
    const { isOpen, closeModal, accept, isEdit, category, selectedCategory } =
      this.props;

    return (
      <Modal
        show={isOpen}
        onHide={closeModal}
        backdrop="static"
        dialogClassName="slide-in-modal"
        className="modal-right"
      >
        <Modal.Header className="modal-header-profile">
          <div className="modal-header">
            <i
              className="fa fa-chevron-left arrow-btn"
              aria-hidden="true"
              onClick={closeModal}
            ></i>
            <Modal.Title className="modal-title-custom">
              {isEdit ? "Edit Category" : "New Category"}
            </Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body className="modal-body-add-doc scrollable-modal-body">
          {this.state.uploadMessage && (
            <div className="upload-status-footer">
              <span>{this.state.uploadMessage}</span>
              {this.state.uploading && (
                <span>{this.state.uploadProgress}%</span>
              )}
            </div>
          )}

          <div className="image-upload-section">
            {this.state.documents.length > 0 &&
            ["image/png", "image/jpeg", "image/jpg", "image/webp"].includes(
              this.state.documents[0].type
            ) ? (
              <img
                className="doc-img-upload"
                onClick={() => this.fileInput.click()}
                src={URL.createObjectURL(this.state.documents[0])}
                alt="Uploaded Preview"
              />
            ) : this.props.isEdit &&
              this.props.selectedCategory &&
              this.props.selectedCategory.imageUrl ? (
              <img
                className="doc-img-upload"
                onClick={() => this.fileInput.click()}
                src={this.props.selectedCategory.imageUrl}
                alt="Existing Preview"
              />
            ) : (
              <div
                className="inventory-category-img"
                onClick={() => this.fileInput.click()}
              >
                <i class="fa fa-picture-o" aria-hidden="true"></i>
              </div>
            )}

            <div
              className={`modal-dropzone ${isDragging ? "dragging" : ""}`}
              onDragOver={this.handleDragOver}
              onDragLeave={this.handleDragLeave}
              onDrop={this.handleDrop}
            >
              <input
                type="file"
                accept={accept}
                onChange={this.handleFileChange}
                style={{ display: "none" }}
                ref={(ref) => (this.fileInput = ref)}
              />
              <button
                type="button"
                className="upload-document-btn"
                onClick={() => this.fileInput.click()}
              >
                <i class="fa fa-picture-o" aria-hidden="true"></i> Upload Files
              </button>
            </div>
          </div>

          <Form
            ref={(c) => {
              this.form = c;
            }}
            onSubmit={
              isEdit ? this.onEditSubmit.bind(this) : this.onSubmit.bind(this)
            }
          >
            <div className="box-form-body">
              <div className="form-group">
                <label>
                  Name<strong className="text-danger">*</strong>
                </label>
                <input
                  type="text"
                  name="categoryName"
                  value={this.state.categoryName || ""}
                  onChange={this.handleInputChange}
                  placeholder="Enter category name"
                  className="form-control"
                  maxLength="30"
                  required
                />
                {!this.state.categoryName && this.state.formSubmitted && (
                  <div className="invalid-feedback">
                    Category name is required
                  </div>
                )}
              </div>
              <div className="form-group">
                <label>Notes</label>
                <input
                  type="text"
                  name="categoryNote"
                  value={this.state.categoryNote || ""}
                  onChange={this.handleInputChange}
                  placeholder="Enter note"
                  className="form-control"
                  maxLength="50"
                />
              </div>
            </div>
          </Form>

          {this.state.errorMessage && (
            <div
              className="error-message"
              style={{ color: "red", marginBottom: "10px" }}
            >
              {this.state.errorMessage}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer-addDocument">
          <button
            className={"save-doc-btn"}
            style={{
              cursor: !this.state.categoryName ? "not-allowed" : "pointer",
            }}
            type="submit"
            disabled={!this.state.categoryName}
            onClick={isEdit ? this.onEditSubmit : this.onSubmit}
          >
            {isEdit ? "Update Category" : "Create New Category"}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotDocuments: state.LotStore.LotDocuments,
    homeownerLotSelectList: state.LotStore.HomeownerLotSelectList,
    HomeownerDocumentCategory: state.LotStore.HomeownerDocumentCategory,
  };
};

export default connect(mapStateToProps)(InventoryCategoryModal);



// WEBPACK FOOTER //
// ./src/Lots/Components/inventoryCategoryAddEditModal.js